module.exports = __webpack_public_path__ + "static/media/Hero_canada_mobile.f5d1f4f3.avif";